var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTread = function SvgTread(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 32h32V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "nonzero",
    d: "M14.124 32c3.085 0 5.593-2.457 5.593-5.5v-4.999h8.175a4.1 4.1 0 0 0 2.943-1.197l.162-.17a3.96 3.96 0 0 0 .956-3.238L29.841 3.398C29.535 1.423 27.8-.022 25.79 0H8l-.017.001H4.27C2.137-.039.3 1.636.01 3.921L0 4.06v10.71l.009.14C.303 17.218 2.156 19.04 4.255 19h3.327l5.631 12.414a1 1 0 0 0 .911.586m.62-2.052L9 17.285V2h16.801c.98-.01 1.818.645 2.034 1.552l.03.153 2.112 13.499c.09.575-.084 1.16-.476 1.601a2.1 2.1 0 0 1-1.598.696h-9.186a1 1 0 0 0-1 1v6c0 1.67-1.205 3.074-2.82 3.419zM7 17H4.711c-1.27.022-2.433-.96-2.692-2.205L2 14.69V4.144l.02-.107c.24-1.132 1.274-1.978 2.527-2.034l.181-.002H7z"
  }))));
};
export default SvgTread;